<template>
  <div class="modify-phone">
    <div class="title-wrap">
      <span class="prev-page" @click="$router.push({ name: 'AccountSettings' })"
        >账号设置
      </span>
      <span class="icon-arrows">></span>
      <span class="current-page">修改手机</span>
    </div>
    <div class="set-content">
      <div class="notice">
        注意:改绑手机号后,银行卡改绑和兑换商城会被限制30天禁止使用
      </div>
      <div class="step-bar">
        <div
          class="step-item"
          :class="{ active: getStepNum == index }"
          v-for="(step, index) in stepArr"
          :key="index"
        >
          <!-- <span class="num"> 盒 </span> -->
          <span class="num">{{ step.num }}</span>
          <div class="txt">{{ step.txt }}</div>
          <div class="line" v-if="index != 2"></div>
        </div>
      </div>
      <OldPhone v-if="$route.name == 'accModifyPhone'"> </OldPhone>
      <router-view v-else></router-view>
    </div>
  </div>
</template>

<script>
import OldPhone from './components/changePhone/oldPhone';
export default {
  name: 'modifyPhone',
  components: {
    OldPhone,
  },
  data() {
    return {
      stepArr: [
        {
          num: 1,
          txt: '验证身份',
        },
        {
          num: 2,
          txt: '设置新手机',
        },
        {
          num: 3,
          txt: '修改成功',
        },
      ],
      stepNum: 0,
    };
  },
  computed: {
    getStepNum() {
      let num = 0;
      this.$route.name == 'accModifyPhone'
        ? (num = 0)
        : this.$route.name == 'accNewPhone'
        ? (num = 1)
        : (num = 2);
      return num;
    },
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;
.modify-phone {
  .title-wrap {
    font-size: 24px;
    color: #595959;
    padding-bottom: 24px;
    border-bottom: 1px solid #d9d9d9;
    .icon-arrows {
      margin: 0 24px;
      color: #8c8c8c;
    }
    .prev-page {
      cursor: pointer;
    }
    .current-page {
      color: #8c8c8c;
    }
  }

  .set-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .notice {
      font-size: 14px;
      color: rgba(255, 0, 0, 0.8);
      margin: 40px 0;
      text-align: center;
    }
    .step-bar {
      color: #8c8c8c;
      display: flex;
      margin-bottom: 55px;

      .step-item {
        display: flex;
        align-items: center;

        .num {
          border: 2px solid #8c8c8c;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          font-weight: 600;
          text-align: center;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .txt {
          font-size: 16px;
          margin: 0 16px;
        }
        .line {
          width: 54px;
          height: 1px;
          background: #d9d9d9;
          margin-right: 16px;
        }
      }
      .active {
        color: $--color-primary;
      }
      .active {
        .num {
          border-color: $--color-primary;
        }
      }
    }
  }
}
</style>
